import { createSlice } from '@reduxjs/toolkit';
import {
  FETCH_PARTS_DATA,
  ADD_PART,
  UPDATE_PART,
  DELETE_PART,
  FETCH_PART_CHAPTER_DATA,
  ADD_CHAPTER,
  UPDATE_CHAPTER,
  DELETE_CHAPTER
} from '../constants/constants';

const initialState = {
  parts: []
};

const findPart = (state, id) => state.parts.find(part => part._id.$oid === id);

const partsSlice = createSlice({
  name: 'parts',
  initialState,
  reducers: {
    part_selected: (state, action) => {
      const part = findPart(state, action.payload);
      if(part) part.selected = !part.selected;
    },
    partMoved: (state, action) => {
      const { dragIndex, hoverIndex } = action.payload;
      let hovered = 0;
      let dragger = 0;

      state.parts.some((item, i) => {
        if (item.sort == hoverIndex) {
          hovered = i;
        }
        if (item.sort == dragIndex) {
          dragger = i;
        }

        if (hovered && dragger) {
          return true;
        }
      });

      // move the dragging item to be next to the hovered item
      const [moved] = state.parts.splice(dragger, 1);
      state.parts.splice(hovered, 0, moved);
    },
    partsSorted: state => {
      state.parts.forEach((part, i) => {
        part.sort = i + 1;
      });
    }
  },
  extraReducers: builder => {
    builder
      .addCase(FETCH_PARTS_DATA, (state, action) => {
        state.parts = action.data.map(item => ({
          ...item,
          selected: false,
          chapters: []
        }));
      })
      .addCase(ADD_PART, (state, action) => {
        state.parts = state.parts.concat(action.data);
      })
      .addCase(UPDATE_PART, (state, action) => {
        const part = findPart(state, action.data._id.$oid);
        if(part) part.title = action.data.title;
      })
      .addCase(DELETE_PART, (state, action) => {
        state.parts = state.parts.filter(part => part._id.$oid !== action.data._id.$oid);
      })
      .addCase(FETCH_PART_CHAPTER_DATA, (state, action) => {
        const part = findPart(state, action.id);
        if(part) part.chapters = action.data;
      })
      .addCase(ADD_CHAPTER, (state, action) => {
        const part = findPart(state, action.data.part_id.$oid);
        if(part) part.chapters = (part.chapters || []).concat(action.data);
      })
      .addCase(UPDATE_CHAPTER, (state, action) => {
        const part = findPart(state, action.data.part_id.$oid);
        if(!part) return;
        part.chapters.forEach(chapter => {
          if(chapter._id.$oid == action.data._id.$oid) {
            chapter.title = action.data.title;
            chapter.part_id = action.data.part_id;
          }
        });
      })
      .addCase(DELETE_CHAPTER, (state, action) => {
        const part = findPart(state, action.data.part_id.$oid);
        if(part) part.chapters = part.chapters.filter(chapter => chapter._id.$oid !== action.data._id.$oid);
      });
  }
});

export const { part_selected, partMoved, partsSorted } = partsSlice.actions;
export default partsSlice.reducer;
